module.exports = __webpack_public_path__ + "img/lift-exit.03a9db33.jpg";